import { useCallback, useEffect, useMemo, useState, type ReactNode } from "react";
import type { FoldStep } from "~/components/ui/bottom-sheet";
import { MapLayoutContext } from "./context";

export default function MapLayoutProvider({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  const [sheetStep, setSheetStep] = useState<FoldStep | null>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  const setSheetStepCb = useCallback((step: FoldStep | null) => {
    setSheetStep(step);
  }, []);

  const value = useMemo(
    () => ({ mounted, sheetStep, setSheetStep: setSheetStepCb }),
    [mounted, sheetStep, setSheetStepCb],
  );

  return <MapLayoutContext.Provider value={value}>{children}</MapLayoutContext.Provider>;
}
